
import React from 'react';
import './PreferinteCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faMusic } from '@fortawesome/free-solid-svg-icons';

const PreferinteCard = ({ darkMode, soundEffects, handleDarkModeToggle, handleSoundEffectsToggle }) => {
  return (
    <div className='preferinte-card'>
      <h4 className='preferinte-card__title preferinte-card__hide-mobile'>Preferinte</h4>
      <div className='preferinte-card__row'>
        <div className='preferinte-card__icon' style={{ background: '#6c63ff' }}>
          <FontAwesomeIcon icon={faMoon} color="#fff" size="lg" />
        </div>
        <div className='preferinte-card__text-block'>
          <div className='preferinte-card__label'>Mod intunecat</div>
          <div className='preferinte-card__desc'>Activeaza tema intunecata pentru a reduce oboseala ochilor</div>
        </div>
        <label className='preferinte-card__toggle'>
          <input type="checkbox" checked={darkMode} onChange={handleDarkModeToggle} />
          <span className='preferinte-card__toggle-slider'></span>
        </label>
      </div>
      <div className='preferinte-card__row'>
        <div className='preferinte-card__icon' style={{ background: '#ff5eae' }}>
          <FontAwesomeIcon icon={faMusic} color="#fff" size="lg" />
        </div>
        <div className='preferinte-card__text-block'>
          <div className='preferinte-card__label'>Efecte sonore</div>
          <div className='preferinte-card__desc'>Reda sunete pentru notificari si actiuni</div>
        </div>
        <label className='preferinte-card__toggle'>
          <input type="checkbox" checked={soundEffects} onChange={handleSoundEffectsToggle} />
          <span className='preferinte-card__toggle-slider'></span>
        </label>
      </div>
    </div>
  );
};

export default PreferinteCard;
